var User = require('user');


var UserChannelMode = Backbone.Model.extend({
    initialize: function (data, options) {
        this.buffer = options.buffer;
        this.connection = this.buffer.connection;
        this.user = options.user || this.makeUser(options);
    },
    makeUser: function (options) {
        var target = {};
        if (this.get('type') == 'channel_mode_list_change') {
            var opList = this.get('ops').add.length ? this.get('ops').add : this.get('ops').remove;
            if (opList.length) {
                target = {
                    nick: opList[0].nick || opList[0].param,
                    hostmask: opList[0].hostmask,
                    ident_prefix: opList[0].ident_prefix,
                    from_name: opList[0].from_name,
                    from_host: opList[0].from_host,
                    from_mode: opList[0].from_mode,
                    from_account: opList[0].from_account,
                    from_realname: opList[0].from_realname,
                    avatar: opList[0].avatar,
                    avatar_url: opList[0].avatar_url,
                    display_name: opList[0].display_name,
                    bot_url: opList[0].bot_url
                };
            }
        } else {
            target = {
                nick: this.get('nick') || this.get('newnick'),
                hostmask: this.get('target_hostmask'),
                ident_prefix: this.get('target_ident_prefix'),
                from_name: this.get('target_name'),
                from_host: this.get('target_host'),
                from_mode: this.get('newmode'),
                from_account: this.get('target_account'),
                from_realname: this.get('target_realname'),
                avatar: this.get('target_avatar'),
                avatar_url: this.get('target_avatar_url'),
                display_name: this.get('target_display_name'),
                bot_url: this.get('target_bot_url')
            };
        }
        return this.connection.makeUserFromTarget(
            this.buffer.bid(),
            target
        );
    },
    getAdded: function () {
        var added = {};
        if (this.get('ops') && this.get('ops').add) {
            _.each(this.get('ops').add, function (add, i) {
                added[add.mode] = add.param;
            });
        }
        return added;
    },
    getRemoved: function () {
        var removed = {};
        if (this.get('ops') && this.get('ops').remove) {
            _.each(this.get('ops').remove, function (remove, i) {
                removed[remove.mode] = remove.param;
            });
        }
        return removed;
    },
    hasAdded: function (mode) {
        return mode in this.getAdded();
    },
    hasRemoved: function (mode) {
        return mode in this.getRemoved();
    },
    getCategory: function () {
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasRemoved(this.connection.getUserModes()[cat]) ||
                     this.hasAdded(this.connection.getUserModes()[cat]);
        }, this) || 'MEMBER';
    },
    getAddedCategory: function () {
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasAdded(this.connection.getUserModes()[cat]);
        }, this);
    },
    getAddedAction: function () {
        var category = this.getAddedCategory();
        if (category) {
            return UserChannelMode.addedActions[category];
        }
    },
    getRemovedCategory: function () {
        return _.find(this.connection.getUserModeHierarchy(), function (cat) {
            return this.hasRemoved(this.connection.getUserModes()[cat]);
        }, this);
    },
    getRemovedAction: function () {
        var category = this.getRemovedCategory();
        if (category) {
            return UserChannelMode.removedActions[category];
        }
    },
    getAction: function () {
        return this.getRemovedAction() || this.getAddedAction();
    },
    isSuperior: function (ucm) {
        return this.connection.getUserModeHierarchy().indexOf(ucm.getCategory()) >
               this.connection.getUserModeHierarchy().indexOf(this.getCategory());
    }
}, {
    getActions: function (modes) {
        return _.unique(_.map(modes, function (m) {
            return m.getAction() || m.get('diff');
        }).reverse()).reverse().join(', ');
    },
    addedActions: {
        'OPER': 'promoted to oper',
        'OWNER': 'promoted to owner',
        'ADMIN': 'promoted to admin',
        'OP': 'opped',
        'HALFOP': 'halfopped',
        'VOICED': 'voiced'
    },
    removedActions: {
        'OPER': 'demoted from oper',
        'OWNER': 'demoted from owner',
        'ADMIN': 'demoted from admin',
        'OP': 'de-opped',
        'HALFOP': 'de-halfopped',
        'VOICED': 'de-voiced'
    }
});



module.exports = UserChannelMode;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/userchannelmode.js
// module id = O4T4
// module chunks = 1